<div class="background-image-container">

    <div class="banner-image">
        <div class="clip-wrapper">
            <div class="left-clip"></div>
        </div>

        <div class="clip-wrapper right-wrapper">
            <div class="right-clip"></div>
        </div>
    </div>

</div>

<div class="icon-column">
    <img src="/build/assets/images/woodcoin.svg" alt="Woodcoins Icon">
</div>

<div class="text-column">
    <h2 class="headline">{{ firstRowHeadlineDesktop }}</h2>

    <h2 class="mobile-tablet-headline" [innerHTML]="firstRowHeadlineMobileAndTablet"></h2>

    <p *ngIf="!mobileService.isMobile">
        {{ secondRowParagraphFirstLine }}
    </p>

    <p *ngIf="!mobileService.isMobile">
        {{ secondRowParagraphSecondLine }} {{ secondRowParagraphThirdLine }}
    </p>

    <p *ngIf="!mobileService.isMobile">
        {{ secondRowLastLine }}
    </p>
</div>

<div class="button-column">

    <div *ngIf="!userService.isLoggedIn; else loggedInButton">

        <button class="blue-button mobileGrowBtn" (click)="dialogService.loginRegistrationDialog('registration')">
            Jetzt Mitglied werden
        </button>

    </div>

    <ng-template #loggedInButton>
        <button class="orange-button mobileGrowBtn" (click)="goto('/profile/boni')">
            Zum Bonussystem
        </button>
    </ng-template>

</div>